import React from 'react';

import InsertMenuToolbarContent from './InsertMenuToolbarContent';
import { InsertRightIcon } from '@milanote/roma-icons';
import RomaToolbarIcon from '../../../roma/RomaToolbarIcon';
import { Popover } from '@milanote/roma';
import useToolbarPopover from '../../../../hooks/useToolbarPopover';
import { Button } from 'react-aria-components';
import ToolbarTool from '../../../ToolbarTool';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { getElementType } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { ElementType } from '../../../../../../../common/elements/elementTypes';

type InsertMenuToolProps = {
    name?: string;
    element?: ImMNElement;
};

const InsertMenuTool: React.FC<InsertMenuToolProps> = ({ name = 'Insert', element, ...toolProps }) => {
    const { isOpen, onOpenChange, onTriggerPress, onTriggerPressStart } = useToolbarPopover();

    const dispatchClosePopup = () => onOpenChange(false);
    const isTaskListContext = getElementType(element) === ElementType.TASK_LIST_TYPE;

    return (
        <div className="InsertMenu ToolbarPopupTool">
            <Popover.MenuTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
                <Button
                    className="Button"
                    aria-label={name}
                    onPress={onTriggerPress}
                    onPressStart={onTriggerPressStart}
                >
                    <ToolbarTool {...toolProps} name={name} isOpen={isOpen} tooltipEnabled={!isOpen}>
                        <RomaToolbarIcon icon={InsertRightIcon} iconClassName="size-5" />
                    </ToolbarTool>
                </Button>
                <Popover className="w-75" placement="end top" offset={4} crossOffset={9}>
                    <InsertMenuToolbarContent
                        closePopup={dispatchClosePopup}
                        size={'md'}
                        isTaskListContext={isTaskListContext}
                    />
                </Popover>
            </Popover.MenuTrigger>
        </div>
    );
};

export default InsertMenuTool;
